var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, Tooltip } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { Component, Fragment } from 'react';
import { getChannelName } from 'utils/channels';
import { mediaAttributes } from 'utils/channels/media';
import { listToAPStyleComma } from 'utils/formatting/string';
import { requestMicrophoneAccess } from 'utils/telephony/microphone';
import { analytics } from '../../../app/utils/segment';
import './../styles/profile.less';
class MediaChannelBadges extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }
    handlePresenceSetMedia(media) {
        const { metaMedia } = this.props;
        const working = !metaMedia.working;
        this.setState({ loading: true });
        this.props
            .presenceSetMedia({ media, working })
            .then(() => {
            this.setState({ loading: false });
            analytics.presenceMediaUpdated({
                media,
                enabled: working,
                location: 'topbar',
            });
        })
            .catch(() => {
            this.setState({ loading: false });
        });
    }
    onChangeHandler() {
        const { metaMedia, telephony } = this.props;
        if (metaMedia.name === 'speak' && telephony.isMicrophoneBlocked) {
            requestMicrophoneAccess()
                .then(this.props.errorMicrophoneErrorShowModal)
                .catch(this.props.errorMicrophoneErrorShowModal)
                .finally(() => {
                // Remove the remember my microphone access.
                this.props.personalToggleRememberMicrophoneAccess({
                    value: false,
                });
            });
        }
        else {
            this.handlePresenceSetMedia(metaMedia.name);
        }
    }
    getChannelListTextVerb(channels) {
        if (channels.length === 1)
            return 'is';
        if (channels.length > 1)
            return `are`;
        return '';
    }
    getChannelStatusText(channels, statusText) {
        return channels.length
            ? `${listToAPStyleComma(channels.map(getChannelName))} ${this.getChannelListTextVerb(channels)} ${statusText}`
            : '';
    }
    getTooltipText() {
        const { metaMedia, presence, telephony } = this.props;
        const { name: mediaName, onChannels, offChannels } = metaMedia;
        const { status } = presence;
        if (mediaName === 'speak') {
            if (telephony.isMicrophoneBlocked) {
                return 'Microphone is blocked. Phone, Callback and voicemail are therefore turned off. Click to enable.';
            }
            if (!telephony.isReady) {
                return telephony.meta.asyncStatus === 'loading'
                    ? 'Loading...'
                    : 'Phone error';
            }
        }
        const onStatusText = status === 'away'
            ? 'inactive because your status is away.'
            : 'turned on.';
        const workingString = this.getChannelStatusText(onChannels, onStatusText);
        const offString = this.getChannelStatusText(offChannels, 'turned off.');
        const interleave = (arr, thing) => []
            .concat(...arr.map((n) => [n, thing]))
            .slice(0, -1);
        // Filter out any empty statusText and interleave with breaklines.
        return interleave([workingString, offString].filter(Boolean), _jsx("br", {})).map((content, i) => _jsx(Fragment, { children: content }, i));
    }
    getChannelAsyncStatus() {
        const { metaMedia, presenceMeta } = this.props;
        switch (metaMedia.name) {
            case 'interactivechat':
                return presenceMeta.chatAsyncStatus;
            case 'speak':
                return presenceMeta.voiceAsyncStatus;
            case 'email':
                return presenceMeta.emailAsyncStatus;
            case 'messaging':
                return presenceMeta.messagingAsyncStatus;
            default:
                return 'failed';
        }
    }
    render() {
        const { metaMedia, presence, telephony } = this.props;
        const { status } = presence;
        let statusClassname = 'disabled';
        if (status !== 'offline' && metaMedia.working) {
            if (status === 'working') {
                statusClassname = 'active working';
            }
            else if (status === 'away') {
                statusClassname = 'active away';
            }
            else {
                statusClassname = 'active';
            }
        }
        const isTelephony = metaMedia.name === 'speak';
        if (isTelephony) {
            if (telephony.isMicrophoneBlocked) {
                statusClassname = 'error';
            }
            else if (!telephony.isReady) {
                statusClassname =
                    telephony.meta.asyncStatus === 'loading' ? 'loading' : 'error';
            }
        }
        const iconClassName = classnames({
            'profile-presence-icon-big': true,
            'icon-animated': this.state.loading === true ||
                this.getChannelAsyncStatus() === 'loading',
        }, statusClassname);
        return (_jsx("span", Object.assign({ className: "badge-item" }, { children: _jsx(Tooltip, Object.assign({ content: this.getTooltipText(), dark: true, wrap: "none" }, { children: _jsx("span", Object.assign({ className: "badge-btn", onClick: this.onChangeHandler }, { children: _jsx(Icon, { name: mediaAttributes[metaMedia.name].icon, size: 24, className: iconClassName }) })) })) })));
    }
}
__decorate([
    boundMethod
], MediaChannelBadges.prototype, "onChangeHandler", null);
export default MediaChannelBadges;
